<template>
    <div>
        <div class="page-header-style">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>Carehome List</b></h4></li>
            </ul>
        </div>
        <br/>
        <transition name="fade" :duration="500">
            <div v-show="isLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <datatable  tablename="datatable-carehome-list" :columns="columns" :source="getRecords" @selected="recordSelected" v-show="!isLoading" ></datatable>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"

    export default  {

        data: function () {
            return {
                isLoading : true,
                columns: [
                    { name: "Name", data: "name" },
                    {
                        name: "Is Active",
                        data: "active",
                        render: function (data, type, row) {
                            return data ? "Active" : "Disabled"
                        }
                    },
                    {
                        name: "Status From",
                        data: "statusFrom",
                        render: Formatter.FormatDate
                    },
                    {
                        name: "Electronic Recording",
                        data: "electronicReorderingEnabled",
                        render: function (data, type, row) {
                            return data ? "Enabled" : "Disabled"
                        }
                    },
                    {
                        name: "Created",
                        data: "whenCreated",
                        render: Formatter.FormatDate
                    }
                ]
            }
        },
        methods: {

            getRecords: function (callback) {

                var dal = new Dal();
                var t0 = performance.now();
                this.isLoading = true;
                var that = this;
                dal.GetCarehomes().then(data => {
                    var filteredData = this.filterCarehomes(data);
                    var records = { data: filteredData };
                    callback(records);
                    var t1 = performance.now();
                    console.log("time diff :", (t1 - t0))
                    setTimeout(() => {
                        that.isLoading = false;
                    }, 500 - (t1 - t0));
                });
            },

            recordSelected: function (record) {
                var id = record.id;
                this.$router.push({ name: 'carehome-main', params: { id } })
            },

            filterCarehomes(carehomes) {
                // If this is a carehome user - portal should only show carehomes for which this user has permission as carheome user
                console.log(this.$root.IsCarehomeUser, carehomes, this.$root.Carehomes )
                if (this.$root.IsCarehomeUser) {
                    var result = [];
                    for (var carehome of carehomes) {
                        if (this.$root.Carehomes.some(c => c.id === carehome.id)) {
                            result.push(carehome);
                        }
                    }
                    return result;
                }
                else {
                    return carehomes;
                }
            }
        },
        components: {
            datatable
        }
    }
</script>


// WEBPACK FOOTER //
// carehome-list.scp.html?3a621850